import Security from "components/Settings/SecurityTab/index";
import AdvancedSettings from "containers/Homepage/OrganizationSetting/Admin/AdvancedSettings";
import React from "react";
import "./individualSecurity.scss";

function IndividualSecurity() {
  return (
    <div className="IndividualSecurity">
      <Security />
      <AdvancedSettings />
    </div>
  );
}

export default IndividualSecurity;
